// extracted by mini-css-extract-plugin
export default {"container":"Partner_container__rwI1f","img":"Partner_img__zJFgS","content":"Partner_content__-b0TW"};